export const userSelector = (state) => state.app.user;

const UserSelector = {
  user: userSelector,
};

export default UserSelector;
